(function($) {
    $(document).ready(function() {

        let $sliders = $('.slider');
        $sliders.each(function() {
			let $slider = $(this);
			try {
				let interval = 5000;
				let $slides = $slider.find('.slide');
				let num = $slides.length;
				$slider.imagesLoaded(function() {
					$slider.flickity({
						cellSelector: '.slide',
						draggable: '>1',
						freeScroll: false,
						wrapAround: true,
						autoPlay: interval,
						prevNextButtons: false,
						// prevNextButtons: (num > 1) ? true : false,
						accessibility: false,
						percentPosition: true,
						pageDots: false,
						// pageDots: (num > 1) ? true : false,
						fade: true,
						arrowShape: "M73.08,97,26.39,50.31,73.08,3.62",
						on: {
							ready: function() {
								
							},
							change: function() {
								//index can be an argument
							}
						}
					});
				});
			} catch(e) {
				let $slides = $slider.find('.slide');
				$slides.each(function(i) {
					if(i > 0) {
						$(this).remove();
					}
				});
			}
		});

		$('.page-id-1012').each(function() {
			// about page
			let $page = $(this);
			let $photo = $page.find('.about-intro');
			let $triangle = $('<svg class="background-triangle" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><polygon fill="#FFFFFF" points="100,0 100,200 0,200 100,0" /></svg>');
			$photo.append($triangle);
		});
    });
	function setSticky() {
		let $header = $('header');
		let $notificationBar = $('.topTextWrapper');
		try {
			
			if( $header.css('position') == 'fixed' ) {
				console.log('fixed');
				console.log($notificationBar.outerHeight() + 'px');
				$header.css('top', $notificationBar.outerHeight() + 'px');
				$('.custom-slider').css('padding-top', $notificationBar.outerHeight() + $header.outerHeight() + 'px');

			} else {
				console.log('not-fixed');
				$header.removeAttr('style');
				$('.custom-slider').removeAttr('style');

			}
		} catch(e) {
			console.log(e);
		}
	}

	$(window).on('resize', function() {
		setSticky();
		let $sliders = $('.slider');
		$sliders.each(function() {
			let $slider = $(this);
			$slider.flickity('resize');
		});
	});
	setSticky();
	
})(jQuery);